

















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class AvatarBanner extends Vue {

    get avatarSrc(): string {
        return require('@/assets/img/avatar/' + this.$currentCompany.virtualColleagueAvatar + '.jpg')
    }

    get hasAvatar(): boolean {
        return !!this.$currentCompany.virtualColleagueAvatar
    }
}
